import { render } from "./PaymentRegular.vue?vue&type=template&id=05c84580&scoped=true&ts=true"
import script from "./PaymentRegular.vue?vue&type=script&lang=ts"
export * from "./PaymentRegular.vue?vue&type=script&lang=ts"

import "./PaymentRegular.vue?vue&type=style&index=0&id=05c84580&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c84580"]])

export default __exports__